import { CLINIC_TZ } from '@/lib/clinic-time';
/** "10:42" today, else "23 Oct, 10:42" (clinic time). */
export function chatTime(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const tz = CLINIC_TZ;
  const day = (x: Date) =>
    x.toLocaleDateString('en-GB', { timeZone: tz, dateStyle: 'short' });
  const time = d.toLocaleTimeString('en-GB', {
    timeZone: tz,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  if (day(d) === day(now)) return time;
  return `${d.toLocaleDateString('en-GB', { timeZone: tz, day: 'numeric', month: 'short' })}, ${time}`;
}
